import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import rfq from "../../images/Icons/rfq.png";
import arrow from "../../images/Icons/arrow-up.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchSentRfq } from "../../redux/slice/sentRfq";
import { fetchReceivedRfq } from "../../redux/slice/receivedRfq";
import config from "../../config";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import { hasPermission, canAccessRoute } from "../../utils/permissionUtils";
import { toast } from "react-toastify";

export default function QuotationList() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = config.user;
  const dispatch = useDispatch();
  const logout = useLogout();

  // Check if user has permission to access this page
  useEffect(() => {
    if (!canAccessRoute('quotation-list')) {
      navigate('/');
      toast.error('You do not have permission to access this page', {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [navigate]);

  const { sentRfqData, isError1 } = useSelector((state) => state.sentRfq);
  const { receivedRfqData, isError2 } = useSelector(
    (state) => state.receivedRfq
  );
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      if (!isError1 && !isError2) {
        setLoading(true);
        try {
          await dispatch(fetchSentRfq(logout));
          await dispatch(fetchReceivedRfq(logout));
        } catch (err) {
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, isError1, isError2, logout]);

  const [filter, setFilter] = useState(
    user && (user.type === "seller" ? "received" : "sent")
  );
  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const getFilteredData = () => {
    switch (filter) {
      case "received":
        return receivedRfqData.map((item) => ({ ...item, type: "received" }));

      default:
        return sentRfqData.map((item) => ({ ...item, type: "sent" }));
    }
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <img src={rfq} alt="icon" />
                    <h5>Quotation List</h5>
                  </div>
                  {user && user.type === "seller" && (
                    <div className="rfq-txt-right">
                      <div className="btn-group" role="group">
                        <Link
                          to="/quotation-list/received"
                          className={`btn btn-sm ${location.pathname === '/quotation-list/received' ? 'btn-danger' : 'btn-outline-danger'}`}
                        >
                          Received
                        </Link>
                        <Link
                          to="/quotation-list/sent"
                          className={`btn btn-sm ${location.pathname === '/quotation-list/sent' ? 'btn-danger' : 'btn-outline-danger'}`}
                        >
                          Sent
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
                <p className="order-note">
                  <span>Note - </span>
                  For all your pending quotations, one of our relationship
                  manager(RM) will reach out to assist you in fulfilling your
                  requirements. In the mean time, please sit back and relax !
                </p>
                {getFilteredData().length > 0 ? (
                  <div className="row g-3">
                    {getFilteredData().map((item, index) => {
                      // Check permissions for view access
                      const canViewQuotation = item.type === "sent" || hasPermission('quotation', 'view');

                      return (
                        <div className="col-lg-4 col-md-6 px-2" key={index}>
                          {canViewQuotation ? (
                            <Link
                              to={
                                item.type === "sent"
                                  ? `/quotation-detail/${item.id}`
                                  : `/seller-quotation-detail/${item.id}`
                              }
                            >
                              <div className="rfq-content">
                                <div className="d-flex flex-row align-items-center">
                                  <div className="left">
                                    <img
                                      src={arrow}
                                      alt=""
                                      className={`img ${item.type === "received" ? "in" : "out"
                                        }`}
                                    />
                                  </div>
                                  <div className="right">
                                    <span>Quotation No: {item.unique_id}</span>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <p>
                                          Quotation{" "}
                                          {item.type === "sent"
                                            ? "sent"
                                            : "received"}{" "}
                                          for {item.commodity_product.name}
                                        </p>
                                      </div>
                                      <div className="col-lg-12 text-dark">
                                        {item.created_at}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="status">
                                  <span>{item.status}</span>
                                </div>
                              </div>
                            </Link>
                          ) : (
                            <div className="rfq-content disabled-content">
                              <div className="d-flex flex-row align-items-center">
                                <div className="left">
                                  <img
                                    src={arrow}
                                    alt=""
                                    className={`img ${item.type === "received" ? "in" : "out"
                                      }`}
                                  />
                                </div>
                                <div className="right">
                                  <span>Quotation No: {item.unique_id}</span>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <p>
                                        Quotation{" "}
                                        {item.type === "sent"
                                          ? "sent"
                                          : "received"}{" "}
                                        for {item.commodity_product.name}
                                      </p>
                                    </div>
                                    <div className="col-lg-12 text-dark">
                                      {item.created_at}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="status">
                                <span>{item.status}</span>
                              </div>
                              <div className="permission-overlay">
                                <small>No permission to view</small>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
